/** The YYYY-MM-DD calendar date an instant belongs to in one IANA timezone. */
export function dayKey(instant: Date, timezone: string): string {
  const parts = new Intl.DateTimeFormat("en-CA", {
    timeZone: timezone,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).formatToParts(instant);
  const value = (type: Intl.DateTimeFormatPartTypes) =>
    parts.find((part) => part.type === type)?.value;
  return `${value("year")}-${value("month")}-${value("day")}`;
}

/** Calendar-day distance, deliberately independent of DST and elapsed hours. */
export function calendarDayDifference(dueAt: string, now: Date, timezone: string): number {
  const midnight = (instant: Date) => {
    const [year, month, day] = dayKey(instant, timezone).split("-").map(Number);
    return Date.UTC(year ?? 0, (month ?? 1) - 1, day ?? 1);
  };
  return Math.round((midnight(new Date(dueAt)) - midnight(now)) / 86_400_000);
}

export function formatDateTime(instant: string, timezone: string): string {
  return new Intl.DateTimeFormat(undefined, {
    timeZone: timezone,
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  }).format(new Date(instant));
}

export function formatDate(instant: string, timezone: string): string {
  return new Intl.DateTimeFormat(undefined, {
    timeZone: timezone,
    year: "numeric",
    month: "short",
    day: "numeric",
  }).format(new Date(instant));
}

const TIMEZONES = [...new Set(["UTC", ...(Intl.supportedValuesOf?.("timeZone") ?? [])])].sort();

export function supportedTimezones(current: string): string[] {
  return TIMEZONES.includes(current) ? TIMEZONES : [current, ...TIMEZONES].sort();
}
